import React, { useState } from "react";
import { Sun, Moon } from "lucide-react";
import { getTheme, setTheme } from "../lib/theme";

export const ThemeToggle = ({ className = "", tid = "theme-toggle-btn" }) => {
  const [theme, setThemeState] = useState(getTheme);
  const toggle = () => {
    const next = theme === "dark" ? "light" : "dark";
    setTheme(next);
    setThemeState(next);
  };
  return (
    <button
      onClick={toggle}
      aria-label={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
      aria-pressed={theme === "dark"}
      title={theme === "dark" ? "Light mode" : "Dark mode"}
      data-testid={tid}
      className={`inline-flex items-center justify-center h-10 w-10 hover:bg-accent transition-colors ${className}`}
    >
      {theme === "dark" ? <Sun size={19} strokeWidth={1.5} /> : <Moon size={19} strokeWidth={1.5} />}
    </button>
  );
};
